<template>
  <div id="app">
    <div>
      <response-menu />
      <app-header @openBpPopup="openBpPopup" /> <!-- 병헌 220208 푸터 > 서포트 > 뷰티플래너조회 > 외부팝업 -> 내부팝업 변경, 이벤트 추가 -->
      <div id="GoContent">
        <router-view />
      </div>
      <app-footer styles="parent-style" @openFootGo="openFootF" @openBpPopup="openBpPopup" /> <!-- 병헌 220208 푸터 > 서포트 > 뷰티플래너조회 > 외부팝업 -> 내부팝업 변경, 이벤트 추가 -->
      <loading v-if="asyncLoading"></loading>
    </div>

  </div>
</template>

<script>
import ResponseMenu from '@/components/header/ResponseMenu.vue';
import AppHeader from '@/components/header/AppHeader.vue';
import AppFooter from '@/components/footer/AppFooter.vue';
import Loading from '@/components/Loading.vue';
import { mapGetters } from 'vuex';
import BpPopup from '@/components/footer/BpPopup.vue'; /* 병헌 220208 푸터 > 서포트 > 뷰티플래너조회 > 외부팝업 -> 내부팝업 변경, 추가 */

export default {
  name: 'App',
  components: {
    AppHeader,
    ResponseMenu,
    AppFooter,
    Loading,
    BpPopup, /* 병헌 220208 푸터 > 서포트 > 뷰티플래너조회 > 외부팝업 -> 내부팝업 변경, 추가 */
  },
  data() {
    return {
      isFoot: {
        value: false,
      },
    };
  },
  methods: {
    openFootF(val) {
      this.isFoot.value = val;
    },
    openBpPopup(val){ /* 병헌 220208 푸터 > 서포트 > 뷰티플래너조회 > 외부팝업 -> 내부팝업 변경, 추가 */
      this.$bvModal.show(val);
    }
  },
  computed: {
    ...mapGetters({
      asyncLoading: 'asyncLoading',
    }),
  },
  provide() {
    return {
      isFootState: this.isFoot, /* 모바일 > 뉴스 > 상세 > 목록 버튼이 푸터가 열렸을 때와 안열렸을 때 위치를 잡기 위한 값 */
    };
  },
};
</script>
<style>
@import './assets/css/ckEditor5.css';
</style>

<style lang="scss">
@import '@/assets/css/layout.scss';
@import '@/assets/css/common.scss';
</style>
